import { play } from "./Application";
import { downgradeComponent } from "@angular/upgrade/static";
import { downgradeInjectable } from "@angular/upgrade/static";
import { Store } from "@ngrx/store";
import {
    LeagueWidgetComponent,
    RosterStatusDialogComponent,
    RosterSelectDialogComponent,
    RosterPreselectDialogComponent,
    ChooseTeamComponent,
    SignupContestantComponent,
    LeaveLeagueComponent,
    LeaveRosterComponent,
} from "@play/league-widget";
import { RestrictionTransformerService, RestrictionFilterService } from "@play/common";
import { ContestantSpotlightComponent } from "../ng2/panels/contestant-spotlight/contestant-spotlight.component";
import { LeagueWinnerContestantComponent } from "../ng2/panels/league-winner/league-winner-contestant.component";
import { LeagueHeaderComponent } from "../ng2/panels/league-header/league-header.component";
import { FfaRankingComponent, RankingFfaPickerComponent } from "@play/ranking/ffa";
import { FfaMatchComponent } from "@play/match/ffa";
import { MatchMediaUploadComponent } from "@play/match/media";
import { ExpansionPanelComponent, PlayCountryNames } from "@play/common";
import { FFAResultContainerComponent } from "@play/admin-ui";
import { AppComponent } from "../app.component";
import { CupPageCupBracketComponent } from "@play/cup-bracket";
import { CupPagePathViewComponent } from "@play/path-view";
import { TournamentListComponent } from "@play/user/league";
import { TeamListComponent, LeaveTeamComponent, JoinTeamComponent, CreateTeamComponent, DeleteTeamComponent } from "@play/user/teams";
import { LoginComponent } from "@play/user/login";
import {
    PlayHeaderComponent,
    FormatDateComponent,
    TrustedBadgeComponent,
    AppBannerComponent,
    PrivacyPolicyPopupComponent,
} from "@play/common";
import { PremiumButtonComponent, PremiumOfferComponent } from "@play/premium";
import { ShopCodeButtonComponent } from "@play/shop";
import { RegionSuggestionComponent } from "@play/region";
import { CaptchaComponent } from "@play/captcha";
import { EseaMatchButtonComponent } from "@play/match";
import { LeagueInformationComponent, LeagueListComponent, LeagueRankingComponent } from "@play/league";
import { PremiumBadgeComponent } from "@play/premium";

play.factory("store", downgradeInjectable(Store));
play.factory("RestrictionTransformerService", downgradeInjectable(RestrictionTransformerService));
play.factory("RestrictionFilterService", downgradeInjectable(RestrictionFilterService));
play.factory("PlayCountryNames", downgradeInjectable(PlayCountryNames));

play.directive("appRoot", downgradeComponent({ component: AppComponent }));
play.directive("leagueWidget", downgradeComponent({ component: LeagueWidgetComponent }));
play.directive("rosterStatusDialog", downgradeComponent({ component: RosterStatusDialogComponent }));
play.directive("rosterPreselectionDialog", downgradeComponent({ component: RosterPreselectDialogComponent }));
play.directive("rosterSelectionDialog", downgradeComponent({ component: RosterSelectDialogComponent }));
play.directive("signupContestant", downgradeComponent({ component: SignupContestantComponent }));
play.directive("leaveLeague", downgradeComponent({ component: LeaveLeagueComponent }));
play.directive("leaveRoster", downgradeComponent({ component: LeaveRosterComponent }));
play.directive("chooseTeam", downgradeComponent({ component: ChooseTeamComponent }));
play.directive("contestantSpotlight", downgradeComponent({ component: ContestantSpotlightComponent }));
play.directive("leagueWinnerContestant", downgradeComponent({ component: LeagueWinnerContestantComponent }));
play.directive("leagueHeader", downgradeComponent({ component: LeagueHeaderComponent }));
play.directive("ffaRanking", downgradeComponent({ component: FfaRankingComponent }));
play.directive("ffaMatch", downgradeComponent({ component: FfaMatchComponent }));
play.directive("rankingFfaPicker", downgradeComponent({ component: RankingFfaPickerComponent }));
play.directive("expansionPanel", downgradeComponent({ component: ExpansionPanelComponent }));
play.directive("matchMediaUpload", downgradeComponent({ component: MatchMediaUploadComponent }));
play.directive("ffaResultContainer", downgradeComponent({ component: FFAResultContainerComponent }));
play.directive("cupPagePathView", downgradeComponent({ component: CupPagePathViewComponent }));
play.directive("cupPageCupBracket", downgradeComponent({ component: CupPageCupBracketComponent }));
play.directive("userTournamentList", downgradeComponent({ component: TournamentListComponent }));
play.directive("userTeamList", downgradeComponent({ component: TeamListComponent }));
play.directive("userLeaveTeam", downgradeComponent({ component: LeaveTeamComponent }));
play.directive("userJoinTeam", downgradeComponent({ component: JoinTeamComponent }));
play.directive("userCreateTeam", downgradeComponent({ component: CreateTeamComponent }));
play.directive("userDeleteTeam", downgradeComponent({ component: DeleteTeamComponent }));
play.directive("playHeader", downgradeComponent({ component: PlayHeaderComponent }));
play.directive("premiumButton", downgradeComponent({ component: PremiumButtonComponent }));
play.directive("premiumOffer", downgradeComponent({ component: PremiumOfferComponent }));
play.directive("shopCodeButton", downgradeComponent({ component: ShopCodeButtonComponent }));
play.directive("regionSuggestion", downgradeComponent({ component: RegionSuggestionComponent }));
play.directive("playCaptcha", downgradeComponent({ component: CaptchaComponent }));
play.directive("eseaMatchButton", downgradeComponent({ component: EseaMatchButtonComponent }));
play.directive("leagueInformation", downgradeComponent({ component: LeagueInformationComponent }));
play.directive("formatDate", downgradeComponent({ component: FormatDateComponent }));
play.directive("leagueList", downgradeComponent({ component: LeagueListComponent }));
play.directive("premiumBadge", downgradeComponent({ component: PremiumBadgeComponent }));
play.directive("trustedBadge", downgradeComponent({ component: TrustedBadgeComponent }));
play.directive("appBanner", downgradeComponent({ component: AppBannerComponent }));
play.directive("userLogin", downgradeComponent({ component: LoginComponent }));
play.directive("privacyPolicyPopup", downgradeComponent({ component: PrivacyPolicyPopupComponent }));
play.directive("leagueRanking", downgradeComponent({ component: LeagueRankingComponent }));
